export const GET_MENU = "get_menu"
export const GET_MENU_SUCCESSFUL = "get_menu_successfull"
export const GET_MENU_FAILED = "get_menu_failed"
